import { useState } from 'react';
import GeneralButton from '../../mainComponents/generalButton';
import CustomAppBar from '../../mainComponents/appBar';
import BigTitle from '../../mainComponents/bigTitle';
import { useNavigate } from 'react-router-dom';
import { updateRegistrationData } from '../../utils/localStorageHelper'; // 👈 import
import { STRINGS } from '../../utils/strings';


export default function PlatformSelection() {
  const navigate = useNavigate();
  const [selected, setSelected] = useState('WhatsApp');

  function handleContinue(): void {
    updateRegistrationData({ platform: selected }); // 👈 much cleaner

    navigate("/chooseuser");
  }

  return (
    <div className="flex flex-col items-center justify-between pt-10 h-screen overflow-hidden bg-[#1a2630] text-white p-5 font-custom">
      <CustomAppBar />

      <div className="text-center space-y-2">
        <BigTitle text="Where do you" />
        <BigTitle text="want to use" />
        <BigTitle text="broChat?" />
      </div>

      <div className="w-full max-w-sm space-y-4">
        {STRINGS.platforms.map(({ name, icon, color, shape }) => (
          <div
            key={name}
            className={`flex items-center justify-between px-5 py-6 rounded-full cursor-pointer transition-all ${
              selected === name ? 'bg-white bg-opacity-10 border-2 border-white' : 'bg-white bg-opacity-10'
            }`}
            onClick={() => setSelected(name)}
          >
            <div className="flex items-center space-x-4">
              <div className={`text-xl p-2 ${color} ${shape === 'squircle' ? 'rounded-xl' : 'rounded-2xl'}`}>
                {icon}
              </div>
              <span className="text-white font-semibold">{name}</span>
            </div>
            {selected === name && <div className="w-3 h-3 bg-white rounded-full" />}
          </div>
        ))}
      </div>

      <GeneralButton text="Continue" color="white" onClick={handleContinue} />

      <div className="h-1" />
    </div>
  );
}
